import {restHelperService} from "./rest-helper.service";

export const friendService = {
    getFriends,
    sendFriendRequest,
    acceptFriendRequest,
    deleteFriend
};

function getFriends() {
    return restHelperService.createGetRequest("/rest/friends")
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function sendFriendRequest(value, sendMethod) {
    let request;
    if (sendMethod === "username") {
        request = {username: value};
    } else {
        request = {friendCode: value};
    }
    return restHelperService.createPostRequest("/rest/friends", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function acceptFriendRequest(friendCode) {
    let request = {friendCode: friendCode};
    return restHelperService.createPostRequest("/rest/friends", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

function deleteFriend(code) {
    let request = {friendCode: code};
    return restHelperService.createDeleteRequest("/rest/friends", request)
        .then(res => {
            let response = restHelperService.getResponse(res);
            return Promise.resolve(response);
        }).catch((res) => {
            return restHelperService.handleCatch(res)
        })
}

